'use strict';
var _ = require('underscore');
import {ARROW_CONFIG} from '../config/index';
import { CoreEntryPoint } from './Core/CoreEntryPoint';
import {checkRunSpeedPerformance} from '../utilities/performanceHelpers';
import {getLogger} from 'loglevel';

const coreEntryPoint = new CoreEntryPoint();
var hasCoreInitialized = false;

const log = getLogger('EntryPoints');

export function initialize(externalEntryPoints) {
  var uikitEntryPoints = {};

  if (!hasCoreInitialized) {
    uikitEntryPoints.core = coreEntryPoint;
    hasCoreInitialized = true;
  }

  _.extend(uikitEntryPoints, externalEntryPoints);

  log.debug(`Number of entry points to initialize: ${_.size(uikitEntryPoints)}`);

  _.each(uikitEntryPoints, (entryPoint, name) => {
    if (entryPoint.shouldInitialize()) {
      log.debug(`Initializing entry point: ${name}`);
      checkRunSpeedPerformance(
        'EntryPoint initialize',
        // allow a bit more flexibility @30fps
        ARROW_CONFIG.framesPerSecondMs[30],
        // should not jank the ui this would be @15fps
        ARROW_CONFIG.framesPerSecondMs[15],
        entryPoint.initialize,
        entryPoint
      )();
      entryPoint.isInitialized = true
    } else {
      log.debug(`Skipping entry point: ${name}`);
    }
  });

  return uikitEntryPoints;
}



// WEBPACK FOOTER //
// ./uikit/entryPoints/index.js